<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">打卡地点编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="打卡地点名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入打卡地点名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设置打卡半径（/米）" required prop="radius">
                                    <el-input v-model="editForm.radius" placeholder="请设置打卡范围半径"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设置迟到时间（/分）" required prop="startTimeSpanLate">
                                    <el-input v-model="editForm.startTimeSpanLate" placeholder="请设置迟到时间"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="状态" required prop="status">
                                   <el-select v-model="editForm.status" placeholder="选择状态" style="width:100%">
                                        <el-option
                                        v-for="item in statusValue"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <div id="container">
                                  <baidu-map @click="getClickInfo"  :center=center :zoom="12" :scroll-wheel-zoom="true">
                                    <bm-view style="width: 100%; height:400px;text-align: center"></bm-view>
                                    <bm-control>
                                      <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 1111}">
                                        <input type="text" placeholder="请输入搜索关键字" class="">
                                      </bm-auto-complete>
                                    </bm-control>
                                    <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;" ></bm-local-search>
                                  </baidu-map>
                                </div>
                              </el-col>
                        </el-row>

                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>
<script charset="utf-8" src="https://map.qq.com/api/js?v=3.exp&key=NBZBZ-S54HS-5VKOL-6RSRS-AXMDE-4DFDF"></script>
<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import qqmap from "qqmap";
    import {BaiduMap, BmAutoComplete, BmControl, BmLocalSearch, BmView} from "vue-baidu-map";

    export default {
      components: {
        BaiduMap,
        BmControl,
        BmView,
        BmAutoComplete,
        BmLocalSearch,
      },
        name: 'Edit',
        data() {
            return {
              keyword: '',
              center:{
                lat: '',
                lng: '',
              },
                loading: false,
                floor:null,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    lon:'',
                    lat:'',
                    radius:'',
                    status:'',
                    clockinPointCode:'',
                    startTimeSpanLate:''
                },
                statusValue:[{label:'正常',value:1},{label:'废弃',value:2}],
                rules:{
                    name:[
                        { required: true, message: '请输入打卡地点名称', trigger: 'blur' },
                    ],
                    radius:[
                        { required: true, message: '请输入打卡范围半径', trigger: 'blur' },
                    ],
                    startTimeSpanLate:[
                        { required: true, message: '请设置迟到时间', trigger: 'blur' },
                    ],
                },
                search:'',
                markersArray: [],
                geocoder:''
            }
        },

        methods: {
          getClickInfo (e) {
            // this.editForm.lat = e.point.lat;
            // this.editForm.lon = e.point.lng;
            console.log("this.editForm: ",this.editForm);
            let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
            let x = e.point.lng - 0.0065;
            let y = e.point.lat - 0.006;
            let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
            let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
            this.editForm.lon = z * Math.cos(theta);
            this.editForm.lat = z * Math.sin(theta);
            this.$message.success("打卡点经纬度抓取成功...");
          },
            onSearch() {
                this.geocoder.getLocation(this.search);
            },
            init(row){
            // 将腾讯QQ地图转换成百度地图
              let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
              let x = row.lon;
              let y = row.lat;
              let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
              let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
              this.center.lng = z * Math.cos(theta) + 0.0065;
              this.center.lat = z * Math.sin(theta) + 0.006;
                var that=this
                this.editForm.clockinPointCode=row.clockinPointCode;
                this.editForm.name=row.name;
                this.editForm.lon=row.lon;
                this.editForm.lat=row.lat;
                this.editForm.status=row.status;
                this.editForm.radius=row.radius;
                this.editForm.startTimeSpanLate=row.startTimeSpanLate;
                // qqmap.init('NBZBZ-S54HS-5VKOL-6RSRS-AXMDE-4DFDF', function() {
                // })
                // var myLatlng = new qq.maps.LatLng(row.lat,row.lon);
                // //定义工厂模式函数
                // var myOptions = {
                //   zoom: 15,               //设置地图缩放级别
                //   center: myLatlng,      //设置中心点样式
                //   mapTypeId: qq.maps.MapTypeId.ROADMAP,  //设置地图样式详情参见MapType
                //   panControl: false,
                //     zoomControlOptions: {
                //         //设置缩放控件的位置为相对左方中间位置对齐.
                //         position: qq.maps.ControlPosition.RIGHT_BOTTOM,
                //         //设置缩放控件样式为仅包含放大缩小两个按钮
                //         style: qq.maps.ZoomControlStyle.DEFAULT
                //     }
                // }
                //
                // //获取dom元素添加地图信息
                // var map = new qq.maps.Map(document.getElementById("map"), myOptions);
                // var marker = new qq.maps.Marker({
                //     position: myLatlng ,
                //     map: map
                // });
                //  qq.maps.event.addListener(map, 'click', function(event) {
                //     that.editForm.lat = event.latLng.getLat();
                //     that.editForm.lon = event.latLng.getLng();
                //     marker.setPosition(event.latLng);
                // });
                // that.geocoder = new qq.maps.Geocoder({
                //     complete: function (result) {
                //         map.setCenter(result.detail.location);
                //         map.setZoom(16)
                //         that.addForm.lat = result.detail.location.getLat();
                //         that.addForm.lon = result.detail.location.getLng();
                //         marker.setPosition(result.detail.location);
                //     }
                // });

            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(!this.editForm.lon||!this.editForm.lat){
                            this.$message.error('请抓取打卡位置')
                        }else{
                            this.addSubmit();
                        }
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.updateTime=new Date()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinPoint/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                          this.keyword = "";
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
                .mapsearch{
                    position: absolute;
                    padding: 10px;
                    z-index: 1000;
                }
            }
            #map{
                width:100%;
                height:400px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
